/**
 * Determines if the current portal is a branded portal.
 *
 * @param group school group
 * @param hostname hostname of the current portal
 * @returns {boolean} true if the current portal is a branded portal
 */
const isBrandedPortal = (group, hostname) => {
  if (!group || !group.subdomain) {
    return false;
  }

  return hostname.startsWith(group.subdomain + ".") === true;
}

export { isBrandedPortal };
